/**
 * Tema em três estados: claro, escuro e "seguir o sistema".
 *
 * "Seguir o sistema" NÃO marca `data-theme` — é a ausência da marca que deixa o CSS
 * cair no `prefers-color-scheme`. Marcar `data-theme="light"` quando o usuário quer
 * "sistema" congela a página no claro e quebra a troca automática ao anoitecer.
 */

export type Theme = 'light' | 'dark' | 'system';

const KEY = 'itens-iterativos:theme';

export function getTheme(): Theme {
  try {
    const v = localStorage.getItem(KEY);
    if (v === 'light' || v === 'dark') return v;
  } catch {
    // armazenamento bloqueado: cai no padrão
  }
  return 'system';
}

export function setTheme(t: Theme): void {
  const root = document.documentElement;
  if (t === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', t);

  try {
    if (t === 'system') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, t);
  } catch {
    // sem persistência; a escolha vale para esta sessão
  }
}

export function applyStoredTheme(): void {
  setTheme(getTheme());
}

export function cycleTheme(): Theme {
  const ordem: Theme[] = ['system', 'light', 'dark'];
  const atual = getTheme();
  const proximo = ordem[(ordem.indexOf(atual) + 1) % ordem.length] as Theme;
  setTheme(proximo);
  return proximo;
}

export const THEME_LABEL: Record<Theme, string> = {
  system: 'Tema: sistema',
  light: 'Tema: claro',
  dark: 'Tema: escuro',
};
